export const css = {
    root: '_3L1f1F6s',
    assess_card: '_1MsODpDC',
    title: 'owZN0L-N',
    actions: 'OYPsIgjl',
    ' _key': 'apic-theme/apic/explore-view/nav-card'
};
export default css;
